import { render, staticRenderFns } from "./PanelCloseHotspots.vue?vue&type=template&id=12a8dfd5&"
import script from "./PanelCloseHotspots.vue?vue&type=script&lang=js&"
export * from "./PanelCloseHotspots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/foxik0169/Projects/rattlecinake.com/themes/ultimatefilms/assets/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('12a8dfd5', component.options)
    } else {
      api.reload('12a8dfd5', component.options)
    }
    module.hot.accept("./PanelCloseHotspots.vue?vue&type=template&id=12a8dfd5&", function () {
      api.rerender('12a8dfd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/PanelCloseHotspots.vue"
export default component.exports